import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "prevBtn", "nextBtn", "pageInfo", "filterBtn"]
  static values = {
    pageSize: { type: Number, default: 10 },
    activeFilter: { type: String, default: "all" }
  }

  connect() {
    this.currentPage = 0
    this.updateView()
  }

  filter(event) {
    const filterValue = event.currentTarget.dataset.filter
    this.activeFilterValue = filterValue
    this.currentPage = 0
    this.updateView()
  }

  nextPage() {
    if (this.currentPage < this.totalPages() - 1) {
      this.currentPage++
      this.updateView()
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--
      this.updateView()
    }
  }

  filteredItems() {
    if (this.activeFilterValue === "all") return this.itemTargets
    return this.itemTargets.filter(item => item.dataset.activityType === this.activeFilterValue)
  }

  totalPages() {
    return Math.max(1, Math.ceil(this.filteredItems().length / this.pageSizeValue))
  }

  updateView() {
    const filtered = this.filteredItems()
    const start = this.currentPage * this.pageSizeValue
    const end = start + this.pageSizeValue

    // Hide all items first
    this.itemTargets.forEach(item => item.classList.add("hidden"))

    // Show only filtered items in current page
    filtered.forEach((item, idx) => {
      item.classList.toggle("hidden", idx < start || idx >= end)
    })

    // Update filter button styles
    this.filterBtnTargets.forEach(btn => {
      const isActive = btn.dataset.filter === this.activeFilterValue
      btn.classList.toggle("btn-active", isActive)
      btn.classList.toggle("btn-primary", isActive)
    })

    // Update pagination
    const total = filtered.length
    const showing = Math.min(end, total)

    if (this.hasPageInfoTarget) {
      if (total === 0) {
        this.pageInfoTarget.textContent = "No events"
      } else {
        this.pageInfoTarget.innerHTML = `${start + 1}&ndash;${showing} of ${total}`
      }
    }

    if (this.hasPrevBtnTarget) this.prevBtnTarget.disabled = this.currentPage === 0
    if (this.hasNextBtnTarget) this.nextBtnTarget.disabled = this.currentPage >= this.totalPages() - 1
  }
}
